import { CHAPTERS, IMAGES } from "../../data/content";
import { Rise } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

export const Manifesto = () => {
  return (
    <section
      id="partnership"
      data-testid="partnership-section"
      className="py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Sticky intro + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Rise>
                <span className="font-mono-ui text-[11px] font-bold uppercase tracking-[0.2em] text-primary">
                  The Partnership
                </span>
                <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.02]">
                  A UK partner for the full journey.
                </h2>
                <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground">
                  FireFlink builds the technology. We make it land — with local contracting,
                  enablement and support tuned to how UK engineering teams actually work.
                </p>
              </Rise>

              <Rise delay={0.1} className="mt-10 overflow-hidden rounded-2xl border border-border">
                <div className="relative">
                  <img
                    src={IMAGES.ukSkyline}
                    alt="London skyline"
                    loading="lazy"
                    decoding="async"
                    className="h-64 w-full object-cover opacity-70"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent" />
                  <div className="absolute bottom-5 left-5 font-mono-ui text-[11px] uppercase tracking-[0.2em] text-foreground">
                    Based in the UK · Serving teams nationwide
                  </div>
                </div>
              </Rise>
            </div>
          </div>

          {/* Numbered chapters */}
          <div className="lg:col-span-7 lg:col-start-6">
            <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2">
              {CHAPTERS.map((c, i) => (
                <Rise
                  key={i}
                  delay={i * 0.06}
                  className="group relative bg-card p-8 lg:p-10 transition-colors duration-500 hover:bg-[#0f0f10]"
                >
                  <div className="flex items-start justify-between">
                    <span className="font-heading text-5xl font-semibold tracking-tighter text-muted-foreground/25 transition-colors duration-500 group-hover:text-primary">
                      {c.no}
                    </span>
                    <ArrowUpRight
                      size={18}
                      strokeWidth={1.5}
                      className="translate-y-1 text-muted-foreground opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100"
                    />
                  </div>
                  <h3 className="mt-8 font-heading text-xl font-medium tracking-tight">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{c.body}</p>
                </Rise>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
